// elem-to-html.ts
import { SlateElement } from "@wangeditor/editor";

// 视频配置
const confVideo = {
  type: "videoAttachment", // 节点 type ，重要！！！
  elemToHtml(elem, childrenHtml) {
    const { videoUrl = "", videoName = "", videoCover = "" } = elem;

    return `
    <a style="cursor: pointer; display: inline-flex; position: relative; border-radius: 4px; overflow: hidden;" data-w-e-type="videoAttachment" data-w-e-is-void data-w-e-is-inline data-videoUrl="${videoUrl}" data-videoName="${videoName}" data-videoCover="${videoCover}" href="javascript:void(0)">
      <img src="${videoCover}" width="300" />
      <span style="position: absolute; width: 100%; height: 100%; left: 0; top: 0; background: rgba(0, 0, 0, 0.3); z-index: 10; display: flex; justify-content: center; align-items: center;">
        <img style="cursor: pointer;" src="https://static.rhkj.com/renhe_fe/other/play-btn1.png" width="40" height="40" />
      </span>
    </a>
  `;
  },
};

// 文件配置
const confFile = {
  type: "fileAttachment", // 节点 type ，重要！！！
  elemToHtml(elem, childrenHtml) {
    const {
      fileStorageId = "",
      fileName = "",
      fileExtension = "",
      fileType = "",
    } = elem;

    const iconUrl = {
      1: "https://renhe-platform-prod.oss-cn-shanghai.aliyuncs.com/2025-12-15/1765795870222_office-excel.png",
    }[fileType];

    return `
    <a style="cursor: pointer; display: inline-flex; position: relative; border-radius: 4px; overflow: hidden; flex-direction: column; align-items: center;" data-w-e-type="fileAttachment" data-w-e-is-void data-w-e-is-inline data-fileStorageId="${fileStorageId}" data-fileName="${fileName}" data-fileExtension="${fileExtension}" data-fileType="${fileType}" href="javascript:void(0)">
      <i style="width: 40px; height: 40px; margin-bottom: 5px; background: url(${iconUrl}); background-size: 100%;"></i>
      <span style="max-width: 100px!important; text-align: justify!important; line-height: 1.4!important; font-size: 13px!important; white-space: normal!important;">${fileName}</span>
    </a>
  `;
  },
};

export default {
  confVideo,
  confFile,
};
